import { LoadingMask } from '@zillow/constellation';
import { ZDocsEditor } from '@zillow/zdocs-web';
import styled from 'styled-components';

// Loading Mask

export const StyledLoadingMask = styled(LoadingMask)`
  display: block;
  min-height: 3rem;
`;

export const FullHeightLoadingMask = styled(LoadingMask)`
  display: block;
  height: 100%;
`;

export const StyledZDocsEditor = styled(ZDocsEditor)`
  display: block;
`;

export const ModalBodyFullHeightLoadingMask = styled(LoadingMask)`
  display: block;
  height: calc(100% - 2rem);
`;

// Durations

export const CSS_TRANSITION_DURATION = 500; // We are speed
